import React from 'react';

const PROJECTS = [
  {
    title: 'Trailer Body Repair',
    description:
      'Damaged side panel and lower rail repaired and restored to like-new condition.',
    before: '/images/trailer-before.jpg',
    after: '/images/trailer-after.jpg',
  },
  {
    title: 'Heavy Equipment Repair',
    description:
      'Component rebuilt and reinstalled for reliable performance.',
    before: '/images/equipment-before.jpg',
    after: '/images/equipment-after.jpg',
  },
  {
    title: 'Engine Repair',
    description:
      'Engine components serviced and restored for performance and reliability.',
    before: '/images/engine-before.jpg',
    after: '/images/engine-after.jpg',
  },
];

export const BeforeAfterSection = () => {
  return (
    <section
      id="before-after"
      className="relative bg-charcoal py-20 md:py-28"
    >
      <div className="absolute inset-0 bg-grid-steel opacity-20" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

        <div className="text-center">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-brand">
            Our Work
          </p>

          <h2 className="mt-3 font-display text-4xl font-extrabold uppercase tracking-wide text-white sm:text-5xl">
            Before & After
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-400">
            Real repairs. Real results. See the difference our workmanship
            makes on trucks, trailers, engines, and heavy equipment.
          </p>
        </div>

        <div className="mt-14 space-y-10">
          {PROJECTS.map((project) => (
            <div
              key={project.title}
              className="border border-line bg-surface p-5 sm:p-7"
            >
              <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-3xl">
                {project.title}
              </h3>

              <div className="mt-6 grid gap-6 md:grid-cols-2">

                <div>
                  <div className="mb-2 font-mono text-xs font-bold uppercase tracking-[0.25em] text-slate-400">
                    Before
                  </div>

                  <div className="overflow-hidden border border-line bg-charcoal">
                    <img
                      src={project.before}
                      alt={`${project.title} before repair`}
                      className="h-72 w-full object-cover sm:h-96"
                    />
                  </div>
                </div>

                <div>
                  <div className="mb-2 font-mono text-xs font-bold uppercase tracking-[0.25em] text-brand">
                    After
                  </div>

                  <div className="overflow-hidden border border-line bg-charcoal">
                    <img
                      src={project.after}
                      alt={`${project.title} after repair`}
                      className="h-72 w-full object-cover sm:h-96"
                    />
                  </div>
                </div>

              </div>

              <p className="mt-5 text-center text-sm leading-relaxed text-slate-400">
                {project.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
